<template>
  <div v-loading="contentLoading">
    <div class="title">基本信息</div>
    <table cellspacing="0" cellpadding="0" class="ReserveOrderTable" style="width: 100%">
      <tr>
        <td class="tableLabel">预留单号</td>
        <td class="tableContent">{{reserveOrder.reservNo}}</td>
        <td class="tableLabel">打印次数</td>
        <td class="tableContent">{{reserveOrder.printCount}}</td>
        <td class="tableLabel">发料状态</td>
        <td class="tableContent">
          <span v-if="reserveOrder.status===1">未发料</span>
          <span v-if="reserveOrder.status===2">部分发料</span>
          <span v-if="reserveOrder.status===3">已发料</span>
        </td>
      </tr>
      <tr>
        <td class="tableLabel">过账状态</td>
        <td class="tableContent">{{reserveOrder.postingStatusDesc}}</td>
        <td class="tableLabel">移动类型</td>
        <td class="tableContent">{{reserveOrder.orderMoveType}}</td>
        <td class="tableLabel">移动类型描述</td>
        <td class="tableContent">{{reserveOrder.orderMoveTypeDesc}}</td>
      </tr>
      <tr>
        <td class="tableLabel">需求日期</td>
        <td class="tableContent">{{reserveOrder.plnOutDate}}</td>
        <td class="tableLabel">内部订单号</td>
        <td class="tableContent">{{reserveOrder.orderId}}</td>
        <td class="tableLabel">创建人</td>
        <td class="tableContent">{{reserveOrder.creatorName}}</td>
      </tr>
      <tr>
        <td class="tableLabel">接收人</td>
        <td class="tableContent">{{reserveOrder.gr_RCPT}}</td>
        <td class="tableLabel">创建时间</td>
        <td class="tableContent">{{reserveOrder.creatorDate}}</td>
        <td class="tableLabel">接收时间</td>
        <td class="tableContent">{{reserveOrder.createTime}}</td>
      </tr>

      <tr>
        <td class="tableLabel">客户地址</td>
        <td class="tableContent">{{reserveOrder.customerAddress}}</td>
        <td class="tableLabel">联系人</td>
        <td class="tableContent">{{reserveOrder.concat}}</td>
        <td class="tableLabel">联系电话</td>
        <td class="tableContent">{{reserveOrder.phone}}</td>
      </tr>
      <tr>
        <td class="tableLabel">备注</td>
        <td class="tableContent" colspan="5">{{reserveOrder.note}}</td>
      </tr>
    </table>
    <div class="title">预留单明细</div>
    <el-table
        ref="elTable"
        :data="reserveOrder.detailList"
        border>
      <el-table-column prop="resItem" align="center" label="行号" width="60"/>
      <el-table-column prop="material" align="center" label="物料号" width="120"/>
      <el-table-column prop="mappingMaterialNo" align="center" label="老物料" width="120"/>
      <el-table-column prop="matlDesc" label="物料描述" show-overflow-tooltip/>
      <el-table-column prop="specification" label="规格型号" show-overflow-tooltip width="200"/>
      <el-table-column prop="entryUom" align="center" label="条目单位" width="70"/>
      <el-table-column prop="reqQuan" align="center" label="需求量" width="80"/>
      <el-table-column prop="locationNo" align="center" label="库存仓位" width="70"/>
      <el-table-column prop="stgeLoc" align="center" label="发料仓库" width="100"/>
      <el-table-column prop="locationNo" align="center" label="小仓位" width="100"/>
      <el-table-column prop="locationNumber" align="center" label="库存" width="80"/>
      <el-table-column prop="shkzg" align="center" label="借/贷标识" width="90"/>
      <el-table-column prop="sendQty" align="center" label="实发数量" width="80"/>
      <el-table-column prop="posted" align="center" label="是否过账" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.posted === true">已过账</span>
          <span v-else>未过账</span>
        </template>
      </el-table-column>
      <el-table-column prop="sendQty" align="center" label="已过帐数量" width="90"/>
      <el-table-column prop="unPostQty" align="center" label="未过帐数量" width="90"/>
      <el-table-column prop="sapDelete" align="center" label="删除标记" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.sapDelete === true" type="danger">已删除</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>

  export default {
    name: "ReserveOrderPreview",
    components: {},
    data() {
      return {
        contentLoading: false,
        reserveOrder: {
          id: "",
          status: "",
          printCount: "",
          createTime: "",
          updateId: "",
          updateName: "",
          updateTime: "",
          plant: "",
          creatorName: "",
          creatorDate: "",
          plnOutDate: "",
          reservNo: "",
          costcenter: "",
          orderId: "",
          gr_RCPT: "",
          rcptid: "",
          statusDesc: "",
          postingStatusDesc: "",
          orderMoveTypeDesc: "",
          plnOutDateDesc: "",
          detailList: [],
        },
      };
    },
    watch: {
      $route: {
        handler: function(val) {
          if (val.name === "ReserveOrderPreview") {
            this.getData(this.$route.query.billId);
          }
        },
      },
    },
    created() {
      this.reserveOrder.id = this.$route.query.billId;
      this.getData(this.$route.query.billId);
    },
    methods: {
      getData(id) {
        this.contentLoading = true;
        this.$http.get("basic", `reserveOrders/${id}`).then(res => {
          if (res.success) {
            this.reserveOrder = res.data;
            this.reserveOrder.detailList.forEach(item => {
              item.unPostQty = item.sendQty - item.sendQty;
            });
          }
        }).finally(() => {
          this.contentLoading = false;
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.ReserveOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}
.ReserveOrderTable td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
}
.title {
  font-size:16px;
  border-bottom:1px solid #ccc;
  width:100%;
  margin:10px 0 5px;
}
.tableLabel {
  width: 240px;
  text-align: left;
  background-color: #D1E6F5;
}
.tableContent {
  text-align: left;
  white-space: pre-wrap;
}
</style>
